import React, { useEffect } from "react";
import "./Privacy_policy.css";
import Common_title from "../common-components/common-title/Common_title";

const Privacy_policy = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <section className="Privacy_policy">
      <div className="container">
        <Common_title subtitle="Privacy Policy for BazarWala" />

        <div className="white_card">
          <p className="point_title">Effective Date: 25 May 2026</p>

          <p className="descn_text">
            At Bazarwala, we respect your privacy and are committed to
            protecting your personal information. This Privacy Policy explains
            how we collect, use, store, and safeguard your data when you visit
            our website, use our mobile application, or place orders through
            WhatsApp or other channels.
          </p>

          <p className="descn_text">
            By using our services, you agree to the practices described in this
            policy.
          </p>

          <br />

          <p className="point_title">1. Information We Collect</p>

          <p className="descn_text">
            To provide a smooth and reliable shopping experience, we may collect
            the following information:
          </p>

          <p className="simple_text">
            <strong>🔹 Personal Information</strong>
          </p>

          <ul className="descn_text">
            <li>Name</li>
            <li>Mobile number</li>
            <li>Email address</li>
            <li>Delivery address</li>
          </ul>

          <p className="simple_text">
            <strong>🔹 Order & Transaction Information</strong>
          </p>

          <ul className="descn_text">
            <li>Products ordered</li>
            <li>Order history</li>
            <li>Delivery preferences</li>
            <li>Payment mode</li>
          </ul>

          <p className="descn_text">
            (We do not store your card, UPI, or banking details.)
          </p>

          <p className="simple_text">
            <strong>🔹 Usage & Technical Information</strong>
          </p>

          <ul className="descn_text">
            <li>Website/app usage data</li>
            <li>Pages visited and features used</li>
            <li>
              Device, browser, and system information (for performance,
              analytics, and security)
            </li>
          </ul>

          <br />

          <p className="point_title">2. How We Use Your Information</p>

          <p className="descn_text">
            Your information is used strictly for legitimate business purposes,
            including:
          </p>

          <ul className="descn_text">
            <li>Processing and delivering your orders</li>
            <li>
              Communicating order confirmations, delivery updates, and service
              notifications
            </li>
            <li>Providing customer support and resolving issues</li>
            <li>Improving our website/app performance and user experience</li>
            <li>Sharing offers or updates only if you opt in</li>
          </ul>

          <p className="descn_text">
            📌 We do not sell, rent, or misuse your personal data.
          </p>

          <br />

          <p className="point_title">3. Customer Communication Preferences</p>

          <ul className="descn_text">
            <li>
              Transactional messages (order updates, delivery notifications) are
              mandatory
            </li>
            <li>Promotional messages are sent only with your consent</li>
            <li>You may opt out of promotional communication at any time</li>
          </ul>

          <br />

          <p className="point_title">4. Your Privacy Rights</p>

          <p className="descn_text">You have the right to:</p>

          <ul className="descn_text">
            <li>Access the personal data we hold about you</li>
            <li>Request correction of inaccurate or outdated information</li>
            <li>
              Request deletion of your data (subject to legal, operational, or
              regulatory requirements)
            </li>
            <li>Withdraw consent for promotional communication</li>
          </ul>

          <p className="descn_text">
            📧 To exercise these rights, contact us through the details below.
          </p>

          <br />

          <p className="point_title">
            5. Sharing Information with Third Parties
          </p>

          <p className="descn_text">
            Your information may be shared only when necessary with trusted
            third parties for:
          </p>

          <ul className="descn_text">
            <li>Payment processing</li>
            <li>Order delivery</li>
            <li>Technical, operational, or customer support services</li>
          </ul>

          <p className="descn_text">
            All partners are required to comply with strict data protection and
            confidentiality standards.
          </p>

          <br />

          <p className="point_title">6. Data Retention</p>

          <p className="descn_text">
            We retain personal data only for as long as necessary to:
          </p>

          <ul className="descn_text">
            <li>Fulfill orders and services</li>
            <li>Comply with legal or regulatory requirements</li>
            <li>Resolve disputes and enforce policies</li>
          </ul>

          <br />

          <p className="point_title">7. Policy Updates</p>

          <p className="descn_text">
            This Privacy Policy may be updated periodically to reflect changes
            in our services, technology, or legal requirements.
          </p>

          <p className="descn_text">
            Any updates will be posted on our website or app. Continued use of
            our services implies acceptance of the revised policy.
          </p>

          <br />

          <p className="point_title">8. Contact Us</p>

          <p className="descn_text">
            For any questions, concerns, or requests related to privacy:
          </p>

          <p className="descn_text">
            📱 <strong>Phone / WhatsApp:</strong> +91 9836886605
          </p>

          <p className="descn_text">
            📧 <strong>Email:</strong> apusikder60@gmail.com 
          </p>

          <p className="descn_text">
            🕘 <strong>Support Hours:</strong> 5:00 AM – 12:00 PM (All Days)
          </p>

          <br />

          <p className="descn_text">
            <strong>Bazarwala</strong>
            <br />
            Fresh • Honest • Local • Never Stored — Delivered with Care
          </p>
        </div>
      </div>
    </section>
  );
};

export default Privacy_policy;
